import { type ReactNode } from "react";
import {
  MarketingTemporalPhasePicker,
  type TemporalPhaseTag,
} from "./MarketingTemporalPhasePicker";

interface MarketingTemporalSelectorProps {
  temporalTags: TemporalPhaseTag[];
  selectedTagId: number | null;
  onSelect: (tagId: number) => void;
  disabled?: boolean;
  /** Renders on the same row as the section title (e.g. step help). */
  headerEnd?: ReactNode;
  /** Shown below the section title, above the options. Prefer help tooltip instead. */
  subtitle?: ReactNode;
}

/** Labeled temporal phase block used by File Detail Promote Classify step. */
export function MarketingTemporalSelector({
  temporalTags,
  selectedTagId,
  onSelect,
  disabled,
  headerEnd,
  subtitle,
}: MarketingTemporalSelectorProps) {
  if (temporalTags.length === 0 && headerEnd == null) return null;

  const headerBlock = (
    <>
      <div className="mb-1.5 flex min-h-7 items-center justify-between gap-2">
        <label className="text-sm font-normal uppercase tracking-wide text-muted-foreground">
          Phase
        </label>
        {headerEnd != null ? <div className="flex shrink-0 items-center">{headerEnd}</div> : null}
      </div>
      {subtitle != null ? (
        <div className="mb-1.5 text-xs text-muted-foreground">{subtitle}</div>
      ) : null}
    </>
  );

  if (temporalTags.length === 0) {
    return <div>{headerBlock}</div>;
  }

  return (
    <div>
      {headerBlock}
      <MarketingTemporalPhasePicker
        tags={temporalTags}
        value={selectedTagId}
        onChange={onSelect}
        disabled={disabled}
        emptyMessage={null}
      />
    </div>
  );
}
